export default {
  components: [
    {
      data: [
        {
          type: "",
          id: "",
          imageUrl: "",
          redirectUrl: "",
          newTab: "",
          altText: "",
          direction: "",
        },
        {
          type: "footer-notes",
          id: "",
          imageUrl: "",
          redirectUrl: "",
          newTab: "",
          altText: "",
          direction: "",
        },
        {
          type: "image",
          id: "awardimage",
          imageUrl: "",
          redirectUrl: "",
          newTab: "TRUE",
          altText: "Airasia - 10 years success",
          direction: "right",
        },
      ]
    }
  ],
  footerNotes: [
    {
      data: [
        {
          content: "©2021 AirAsia Group Berhad. This website is owned and operated by AirAsia Com Travel Sdn Bhd (201301020508), a registered travel agency (KPK/LN License No: 8287). Your usage of this website indicates that you agree to be bound by our {0}, {1} and {2}. {3} {4} {5}",
          id: "footerTopLinks",
        },
        {
          content: "{0} | {1} | {2} | {3} | {4}",
          id: "footerBottomLinks",
        },
      ]
    }
  ],
  footerTopLinks: [
    {
      data: [
        {
          label: "Terms and Conditions",
          url: "https://www.airasia.com/aa/about-us/en/gb/terms-and-conditions.html",
          cnUrl: "https://www.airasia.com/aa/about-us/en/gb/terms-and-conditions.html",
          newTab: "TRUE",
        },
        {
          label: "Terms of Use",
          url: "https://www.airasia.com/aa/about-us/en/gb/terms-of-use.html",
          cnUrl: "https://www.airasia.com/aa/about-us/en/gb/terms-of-use-cn.html",
          newTab: "TRUE",
        },
        {
          label: "Privacy Statement",
          url: "https://www.airasia.com/aa/about-us/en/gb/privacy-statement.html",
          cnUrl: "https://www.airasia.com/aa/about-us/en/gb/privacy-statement-cn.html",
          newTab: "TRUE",
        },
        {
          label: "亚航商务服务(广州)有限公司",
          url: "https://www.airasia.com/zh/cn",
          cnUrl: "",
          newTab: "TRUE",
        },
        {
          label: "粤ICP备17160544号-2",
          url: "https://beian.miit.gov.cn/#/Integrated/recordQuery",
          cnUrl: "",
          newTab: "TRUE",
        },
        {
          label: "证照信息",
          url: "https://a.staticaa.com/pdf/business-license/wofe-business-license.pdf",
          cnUrl: "",
          newTab: "TRUE",
        },
      ]
    }
  ],
  footerBottomLinks: [
    {
      data: [
        {
          label: "AirAsia Berhad (Malaysia)",
          url: "https://ir.airasia.com/corporate_structure.html",
          cnUrl: "",
          newTab: "TRUE",
        },
        {
          label: "Thai AirAsia Co. Ltd",
          url: "https://www.aavplc.com/en/thai-airasia-taa/organisation-structure",
          cnUrl: "",
          newTab: "TRUE",
        },
        {
          label: "PT Indonesia AirAsia",
          url: "https://www.airasia.com/aa/about-us/en/gb/airasia-indonesia-organizational-structure.html",
          cnUrl: "",
          newTab: "TRUE",
        },
        {
          label: "Philippines AirAsia Inc.",
          url: "https://www.airasia.com/aa/about-us/en/gb/airasia-philippine-organizational-structure.html",
          cnUrl: "",
          newTab: "TRUE",
        },
        {
          label: "AirAsia (India) Limited",
          url: "https://www.airasia.com/aa/about-us/en/gb/airasia-india-organizational-structure.html",
          cnUrl: "",
          newTab: "TRUE",
        },
      ]
    }
  ],
}